/// <amd-module name="Build/Admin/Pool/Components/PoolChecksContainer" />
import * as React from "react";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { StoresHub } from "Build/Admin/Pool/Stores/StoresHub";
import { StoreStatus } from "Build/Admin/Common/Constants";
import { ChecksOverview } from "Checks/ChecksOverview/ChecksOverview";
import { TaskAgentQueue } from "DistributedTask/Client/Contracts/TaskAgent";

export interface IPoolChecksContainerProps {
    storesHub: StoresHub;
}

export interface IPoolChecksContainerState {
    checksDataLoaded: StoreStatus;
    agentQueue: TaskAgentQueue | undefined;
    hasManagePermission: boolean;
}

export class PoolChecksContainer extends VssComponent<IPoolChecksContainerProps, IPoolChecksContainerState> {

    constructor(props: IPoolChecksContainerProps, context: IVssComponentContext) {
        super(props, context);
        this.state = this._getStateFromStores();
    }

    public componentDidMount(): void {
        this.props.storesHub.checksStore.addChangedListener(this._onChanged);
        this.props.storesHub.securityStore.addChangedListener(this._onChanged);
    }

    public componentWillUnmount(): void {
        this.props.storesHub.checksStore.removeChangedListener(this._onChanged);
        this.props.storesHub.securityStore.removeChangedListener(this._onChanged);
    }

    public render() {
        if (this.state.agentQueue && this.state.checksDataLoaded === StoreStatus.Loaded) {
            return (
                <ChecksOverview
                    resourceType={"queue"}
                    resourceId={this.state.agentQueue.id.toString()}
                    resourceName={this.state.agentQueue.name}
                    hasManagePermission={this.state.hasManagePermission}
                    dataProviderRequestParameters={{ "queueId": this.state.agentQueue.id }} 
                />
            );
        }
        return null;
    }

    private _onChanged = (): void => {
        this.setState(this._getStateFromStores());
    }

    private _getStateFromStores(): IPoolChecksContainerState {
        return {
            checksDataLoaded: this.props.storesHub.checksStore.state.status,
            agentQueue: this.props.storesHub.selectionStore.state.selectedAgentQueue,
            hasManagePermission: this.props.storesHub.securityStore.state.hasManageQueuePermission
        };
    }
}
